import React from 'react';

const AttachIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9502 3.80108C13.8849 2.73297 12.1585 2.73297 11.0932 3.80108L5.55919 9.34953C3.8136 11.0997 3.8136 13.938 5.55919 15.6882C7.30369 17.4373 10.1313 17.4373 11.8758 15.6882L11.8783 15.6856L14.7582 12.8261C15.0522 12.5343 15.527 12.536 15.8189 12.8299C16.1107 13.1238 16.109 13.5987 15.8151 13.8905L12.9378 16.7475L12.9365 16.7488C10.6058 19.0842 6.8273 19.0837 4.49714 16.7475C2.16762 14.4119 2.16762 10.6259 4.49714 8.29026L10.0311 2.74181C11.6825 1.08606 14.3608 1.08606 16.0122 2.74181C17.6626 4.39646 17.6626 7.07838 16.0122 8.73304L10.4783 14.2815C9.50604 15.2563 7.92892 15.2563 6.95669 14.2815C5.98553 13.3078 5.98553 11.7299 6.95669 10.7562L6.95908 10.7538L10.0614 7.67137C10.3553 7.37942 10.8302 7.38095 11.1221 7.67478C11.4141 7.96861 11.4125 8.44348 11.1187 8.73543L8.01873 11.8155L8.01771 11.8165C7.63152 12.2048 7.63185 12.8343 8.01873 13.2222C8.40486 13.6094 9.0301 13.6094 9.41623 13.2222L14.9502 7.67376C16.0166 6.60458 16.0166 4.87027 14.9502 3.80108Z"
      fill="currentColor"
    />
  </svg>
);

export default AttachIcon;
